// @ts-ignore
import { usePaymentSource } from '@zapier/payment';

import {
  useCurrentAccountId,
  useNextPlan,
} from '@zapier/design-system-revenue/src/hooks';

import { useAutoUpgrade } from '../useAutoUpgrade';

export const useData = () => {
  const { accountId } = useCurrentAccountId();
  const { isLoading: isLoadingNextPlan, nextPlan } = useNextPlan();

  const {
    isLoading: isLoadingAutoUpgrade,
    isOnExtendedTrial,
    isAutoUpgradeEnabled,
    onToggleAutoUpgrade,
    trialDaysLeft,
  } = useAutoUpgrade();

  const {
    isLoading: isLoadingPaymentSource,
    primarySource,
  } = usePaymentSource({ accountId });

  const nextPlanAmount =
    nextPlan?.intervals?.find(interval => interval.interval === 'month')
      ?.monthlyAmount ?? -1;

  return {
    handleToggleAutoUpgrade: () => {
      onToggleAutoUpgrade();
    },
    hasPaymentSource: Boolean(primarySource),
    isLoading:
      isLoadingNextPlan || isLoadingPaymentSource || isLoadingAutoUpgrade,
    isAutoUpgradeEnabled,
    isOnExtendedTrial,
    nextPlanAmount,
    trialDaysLeft,
  };
};
